export default function Interests() {
    return (
        <div className="int-container">
            <h3 className="int">Interests</h3>
            <p className="my-int">I've always been a creative. Coding, music theory, music production, songwriting, technology lover, vedic astrology, self improvement.</p>
        </div>
    )
}